import * as React from "react";
import {Display} from "../../../components/Display";

export interface ValidatedEquipmentModalElementProps {
    itemClassName?: string;
    statusTitle: string;
    statusTitleClassName?: string;
    statusDescription: string;
    statusDescriptionClassName?: string;
    statusIconName?: string;
    statusIconNameClassName?: string;
}

export const ValidatedEquipmentModalElement: React.FC<ValidatedEquipmentModalElementProps> = ({
                                                                                                  statusDescription,
                                                                                                  statusTitle,
                                                                                                  statusIconName,
                                                                                                  statusDescriptionClassName,
                                                                                                  statusIconNameClassName,
                                                                                                  itemClassName,
                                                                                                  statusTitleClassName
                                                                                              }) => {
    return (
        <div className={`legend-item-status ${itemClassName}`}>
            <Display isVisible={statusIconName !== undefined}>
                <span className={`material-symbols-outlined icon ${statusIconNameClassName}`}>{statusIconName}</span>
            </Display>
            <h2 className={`legend-item-section-title bold ${statusTitleClassName}`}>{statusTitle}</h2>
            <p className={`legend-item-status-description ${statusDescriptionClassName}`}>{statusDescription}</p>
        </div>
    )
}